import mogomaLogo from "../../../../assets/logo.png";

const COLORS = {
    navy: "#071D54",
    blue: "#2453FF",
    darkBlue: "#123DDA",
    white: "#FFFFFF",
    background: "#F5F7FC",
    paleBlue: "#EAF1FF",
    lightBlue: "#EDF3FF",
    border: "#E0E6F0",
    muted: "#59657D",
};

const loadImage = (src) => {
    return new Promise((resolve) => {
        if (!src) {
            resolve(null);
            return;
        }

        const image = new Image();

        image.crossOrigin = "anonymous";

        image.onload = () => resolve(image);
        image.onerror = () => resolve(null);

        image.src = src;
    });
};

const roundedRect = (
    ctx,
    x,
    y,
    width,
    height,
    radius,
    fill,
    stroke = null,
    strokeWidth = 1
) => {
    ctx.beginPath();

    ctx.roundRect(
        x,
        y,
        width,
        height,
        radius
    );

    if (fill) {
        ctx.fillStyle = fill;
        ctx.fill();
    }

    if (stroke) {
        ctx.strokeStyle = stroke;
        ctx.lineWidth = strokeWidth;
        ctx.stroke();
    }
};

const drawText = (
    ctx,
    value,
    x,
    y,
    size,
    weight,
    color,
    align = "left",
    family = "Arial"
) => {
    ctx.font =
        `${weight} ${size}px ${family}`;

    ctx.fillStyle = color;
    ctx.textAlign = align;
    ctx.textBaseline = "alphabetic";

    ctx.fillText(
        value,
        x,
        y
    );
};

const drawWrappedText = (
    ctx,
    text,
    x,
    y,
    maxWidth,
    size,
    weight,
    color,
    lineHeight,
    family = "Arial"
) => {
    ctx.font =
        `${weight} ${size}px ${family}`;

    ctx.fillStyle = color;
    ctx.textAlign = "left";
    ctx.textBaseline = "alphabetic";

    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    words.forEach((word) => {
        const testLine = currentLine
            ? `${currentLine} ${word}`
            : word;

        if (
            ctx.measureText(testLine).width <=
            maxWidth
        ) {
            currentLine = testLine;
        } else {
            if (currentLine) {
                lines.push(currentLine);
            }

            currentLine = word;
        }
    });

    if (currentLine) {
        lines.push(currentLine);
    }

    lines.forEach((line, index) => {
        ctx.fillText(
            line,
            x,
            y + index * lineHeight
        );
    });

    return lines.length;
};

const drawLine = (
    ctx,
    x1,
    y1,
    x2,
    y2,
    color,
    width = 1
) => {
    ctx.beginPath();

    ctx.moveTo(
        x1,
        y1
    );

    ctx.lineTo(
        x2,
        y2
    );

    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.stroke();
};

const drawCircle = (
    ctx,
    x,
    y,
    radius,
    fill
) => {
    ctx.beginPath();

    ctx.arc(
        x,
        y,
        radius,
        0,
        Math.PI * 2
    );

    ctx.fillStyle = fill;
    ctx.fill();
};

const drawIconBox = (
    ctx,
    x,
    y,
    type
) => {
    roundedRect(
        ctx,
        x,
        y,
        66,
        66,
        15,
        COLORS.paleBlue
    );

    const centerX = x + 33;
    const centerY = y + 33;

    ctx.strokeStyle = COLORS.blue;
    ctx.fillStyle = COLORS.blue;
    ctx.lineWidth = 3;

    if (type === "phone") {
        ctx.save();

        ctx.strokeStyle = COLORS.blue;
        ctx.lineWidth = 4;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";

        ctx.beginPath();

        ctx.moveTo(
            centerX - 11,
            centerY - 15
        );

        ctx.quadraticCurveTo(
            centerX - 15,
            centerY - 17,
            centerX - 17,
            centerY - 12
        );

        ctx.quadraticCurveTo(
            centerX - 16,
            centerY + 4,
            centerX - 5,
            centerY + 13
        );

        ctx.quadraticCurveTo(
            centerX + 5,
            centerY + 20,
            centerX + 14,
            centerY + 13
        );

        ctx.quadraticCurveTo(
            centerX + 18,
            centerY + 10,
            centerX + 14,
            centerY + 6
        );

        ctx.lineTo(
            centerX + 7,
            centerY + 1
        );

        ctx.quadraticCurveTo(
            centerX + 4,
            centerY,
            centerX + 2,
            centerY + 3
        );

        ctx.lineTo(
            centerX - 1,
            centerY + 6
        );

        ctx.quadraticCurveTo(
            centerX - 7,
            centerY + 2,
            centerX - 10,
            centerY - 4
        );

        ctx.lineTo(
            centerX - 7,
            centerY - 9
        );

        ctx.quadraticCurveTo(
            centerX - 8,
            centerY - 13,
            centerX - 11,
            centerY - 15
        );

        ctx.stroke();

        ctx.restore();
    }

    if (type === "email") {
        ctx.lineWidth = 3;

        ctx.strokeRect(
            centerX - 18,
            centerY - 13,
            36,
            27
        );

        ctx.beginPath();

        ctx.moveTo(
            centerX - 18,
            centerY - 12
        );

        ctx.lineTo(
            centerX,
            centerY + 2
        );

        ctx.lineTo(
            centerX + 18,
            centerY - 12
        );

        ctx.stroke();
    }

    if (type === "calendar") {
        ctx.lineWidth = 3;

        ctx.strokeRect(
            centerX - 17,
            centerY - 14,
            34,
            31
        );

        drawLine(
            ctx,
            centerX - 17,
            centerY - 5,
            centerX + 17,
            centerY - 5,
            COLORS.blue,
            3
        );

        drawLine(
            ctx,
            centerX - 9,
            centerY - 20,
            centerX - 9,
            centerY - 9,
            COLORS.blue,
            4
        );

        drawLine(
            ctx,
            centerX + 9,
            centerY - 20,
            centerX + 9,
            centerY - 9,
            COLORS.blue,
            4
        );

        [
            [-9, 4],
            [0, 4],
            [9, 4],
            [-9, 13],
            [0, 13],
            [9, 13],
        ].forEach(([dx, dy]) => {
            drawCircle(
                ctx,
                centerX + dx,
                centerY + dy,
                2,
                COLORS.blue
            );
        });
    }

    if (type === "shield") {
        ctx.beginPath();

        ctx.moveTo(
            centerX,
            centerY - 18
        );

        ctx.lineTo(
            centerX + 17,
            centerY - 11
        );

        ctx.lineTo(
            centerX + 14,
            centerY + 9
        );

        ctx.quadraticCurveTo(
            centerX,
            centerY + 20,
            centerX,
            centerY + 20
        );

        ctx.quadraticCurveTo(
            centerX,
            centerY + 20,
            centerX - 14,
            centerY + 9
        );

        ctx.lineTo(
            centerX - 17,
            centerY - 11
        );

        ctx.closePath();

        ctx.stroke();

        ctx.beginPath();

        ctx.moveTo(
            centerX - 7,
            centerY
        );

        ctx.lineTo(
            centerX - 1,
            centerY + 6
        );

        ctx.lineTo(
            centerX + 9,
            centerY - 6
        );

        ctx.stroke();
    }
};

const drawVerifiedIcon = (
    ctx,
    x,
    y
) => {
    const outerRadius = 18;
    const innerRadius = 15;
    const points = 12;

    ctx.save();

    ctx.beginPath();

    for (
        let i = 0;
        i < points * 2;
        i++
    ) {
        const angle =
            (Math.PI * 2 * i) /
                (points * 2) -
            Math.PI / 2;

        const radius =
            i % 2 === 0
                ? outerRadius
                : innerRadius;

        const px =
            x +
            Math.cos(angle) *
                radius;

        const py =
            y +
            Math.sin(angle) *
                radius;

        if (i === 0) {
            ctx.moveTo(px, py);
        } else {
            ctx.lineTo(px, py);
        }
    }

    ctx.closePath();

    ctx.fillStyle = COLORS.blue;
    ctx.fill();

    ctx.strokeStyle = COLORS.white;
    ctx.lineWidth = 3.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";

    ctx.beginPath();

    ctx.moveTo(
        x - 7,
        y
    );

    ctx.lineTo(
        x - 1,
        y + 6
    );

    ctx.lineTo(
        x + 9,
        y - 7
    );

    ctx.stroke();

    ctx.restore();
};

export const generateDriverPartnerPoster = async ({
    user,
    driverPartner,
    mediaBaseUrl = "",
}) => {
    const canvas =
        document.createElement("canvas");

    const ctx =
        canvas.getContext("2d");

    const WIDTH = 1086;
    const HEIGHT = 1208;

    canvas.width = WIDTH;
    canvas.height = HEIGHT;

const profileDocument =
    user?.documents?.find(
        (doc) =>
            doc.document_type === "Profile Image"
    );

const profileImageUrl =
    profileDocument?.file_path
        ? `${mediaBaseUrl.replace(
              /\/$/,
              ""
          )}/${profileDocument.file_path.replace(
              /^\//,
              ""
          )}`
        : null;


const profileImg =
    await loadImage(profileImageUrl);

    const logoImg =
        await loadImage(mogomaLogo);

    const fullName = [
        user?.first_name,
        user?.last_name,
    ]
        .filter(Boolean)
        .join(" ")
        .trim() ||
        "Mogoma Driver Partner";

    const phone =
        user?.phone_number ||
        "Not provided";

    const email =
        user?.email ||
        "Not provided";

    const referralCode =
        driverPartner?.partner_referral_code ||
        "N/A";

    const status =
        driverPartner?.status ||
        "Active";

    const joinedDate =
        driverPartner?.created_at
            ? new Date(
                  driverPartner.created_at
              ).toLocaleDateString(
                  "en-GB",
                  {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                  }
              )
            : "N/A";

    // ---------------------------------------------------------
    // BACKGROUND
    // ---------------------------------------------------------

    ctx.clearRect(
        0,
        0,
        WIDTH,
        HEIGHT
    );

    const background =
        ctx.createLinearGradient(
            0,
            0,
            WIDTH,
            HEIGHT
        );

    background.addColorStop(
        0,
        "#FFFFFF"
    );

    background.addColorStop(
        0.55,
        "#FAFBFF"
    );

    background.addColorStop(
        1,
        "#EDF3FF"
    );

    ctx.fillStyle = background;

    ctx.fillRect(
        0,
        0,
        WIDTH,
        HEIGHT
    );

    // ---------------------------------------------------------
    // TOP RIGHT BLUE SHAPE
    // ---------------------------------------------------------

    ctx.fillStyle =
        COLORS.darkBlue;

    ctx.beginPath();

    ctx.moveTo(
        800,
        0
    );

    ctx.lineTo(
        WIDTH,
        0
    );

    ctx.lineTo(
        WIDTH,
        280
    );

    ctx.bezierCurveTo(
        1010,
        250,
        970,
        215,
        925,
        185
    );

    ctx.bezierCurveTo(
        870,
        150,
        845,
        115,
        825,
        70
    );

    ctx.bezierCurveTo(
        815,
        35,
        805,
        12,
        800,
        0
    );

    ctx.closePath();

    ctx.fill();

    // ---------------------------------------------------------
    // LOGOS
    // ---------------------------------------------------------

    if (logoImg) {
        ctx.save();

        ctx.globalAlpha = 0.18;

        ctx.drawImage(
            logoImg,
            700,
            75,
            300,
            210
        );

        ctx.restore();

        ctx.drawImage(
            logoImg,
            955,
            55,
            95,
            66
        );

        ctx.drawImage(
            logoImg,
            55,
            92,
            115,
            80
        );
    }

    drawText(
        ctx,
        "Mogoma",
        185,
        135,
        55,
        "700",
        COLORS.navy,
        "left",
        "Georgia"
    );

    drawText(
        ctx,
        "Motshwarele gone hoo...!",
        188,
        165,
        18,
        "italic 500",
        COLORS.blue
    );

    // ---------------------------------------------------------
    // TITLE
    // ---------------------------------------------------------

    drawText(
        ctx,
        "I AM A",
        70,
        385,
        65,
        "900",
        COLORS.navy
    );

    drawText(
        ctx,
        "MOGOMA DRIVER PARTNER",
        70,
        449,
        65,
        "900",
        COLORS.blue
    );

    drawText(
        ctx,
        "Partner today, Grow Together.",
        72,
        508,
        29,
        "500",
        COLORS.navy
    );

    roundedRect(
        ctx,
        72,
        536,
        80,
        9,
        5,
        COLORS.blue
    );

    drawCircle(
        ctx,
        168,
        540,
        5,
        COLORS.blue
    );

    // ---------------------------------------------------------
    // CARD
    // ---------------------------------------------------------

    ctx.save();

    ctx.shadowColor =
        "rgba(7,29,84,0.10)";

    ctx.shadowBlur = 30;
    ctx.shadowOffsetY = 8;

    roundedRect(
        ctx,
        53,
        577,
        980,
        590,
        30,
        COLORS.white
    );

    ctx.restore();

    // ---------------------------------------------------------
    // PROFILE IMAGE
    // ---------------------------------------------------------

    drawCircle(
        ctx,
        197,
        711,
        100,
        COLORS.paleBlue
    );

    ctx.save();

    ctx.beginPath();

    ctx.arc(
        197,
        711,
        91,
        0,
        Math.PI * 2
    );

    ctx.clip();

    if (profileImg) {
        ctx.drawImage(
            profileImg,
            106,
            620,
            182,
            182
        );
    } else if (logoImg) {
        ctx.drawImage(
            logoImg,
            145,
            670,
            105,
            73
        );
    }

    ctx.restore();

    // ---------------------------------------------------------
    // NAME
    // ---------------------------------------------------------

    const nameLines =
        drawWrappedText(
            ctx,
            fullName.toUpperCase(),
            331,
            673,
            650,
            40,
            "900",
            COLORS.navy,
            46
        );

    const verifiedY =
        nameLines > 1
            ? 782
            : 735;

    drawVerifiedIcon(
        ctx,
        352,
        verifiedY
    );

    drawText(
        ctx,
        "Verified Mogoma Driver Partner",
        386,
        verifiedY + 8,
        20,
        "700",
        COLORS.blue
    );

    // ---------------------------------------------------------
    // PHONE
    // ---------------------------------------------------------

    drawLine(
        ctx,
        88,
        840,
        998,
        840,
        COLORS.border,
        2
    );

    drawIconBox(
        ctx,
        92,
        870,
        "phone"
    );

    drawText(
        ctx,
        "PHONE NUMBER",
        185,
        894,
        14,
        "700",
        COLORS.muted
    );

    drawText(
        ctx,
        phone,
        185,
        927,
        22,
        "800",
        COLORS.navy
    );

    // ---------------------------------------------------------
    // EMAIL
    // ---------------------------------------------------------

    drawLine(
        ctx,
        502,
        869,
        502,
        934,
        COLORS.border,
        2
    );

    drawIconBox(
        ctx,
        545,
        870,
        "email"
    );

    drawText(
        ctx,
        "EMAIL ADDRESS",
        638,
        894,
        14,
        "700",
        COLORS.muted
    );

    drawText(
        ctx,
        email,
        638,
        927,
        19,
        "800",
        COLORS.navy
    );

    // ---------------------------------------------------------
    // ID CARD
    // ---------------------------------------------------------

    drawLine(
        ctx,
        88,
        967,
        998,
        967,
        COLORS.border,
        2
    );

    roundedRect(
        ctx,
        88,
        990,
        430,
        145,
        15,
        COLORS.lightBlue
    );

    drawText(
        ctx,
        "DRIVER PARTNER ID",
        109,
        1026,
        15,
        "900",
        COLORS.blue
    );

    drawText(
        ctx,
        referralCode,
        109,
        1073,
        36,
        "900",
        COLORS.blue
    );

    drawText(
        ctx,
        "Keep your Driver Partner ID safe.",
        109,
        1108,
        16,
        "500",
        COLORS.navy
    );

    drawText(
        ctx,
        "You may need it when contacting support.",
        109,
        1132,
        16,
        "500",
        COLORS.navy
    );

    roundedRect(
        ctx,
        109,
        1150,
        45,
        5,
        3,
        COLORS.blue
    );

    drawCircle(
        ctx,
        160,
        1152,
        4,
        COLORS.blue
    );

    // ---------------------------------------------------------
    // JOINED
    // ---------------------------------------------------------

    drawIconBox(
        ctx,
        674,
        1008,
        "calendar"
    );

    drawText(
        ctx,
        "JOINED ON",
        707,
        1098,
        11,
        "700",
        COLORS.muted,
        "center"
    );

    drawText(
        ctx,
        joinedDate,
        707,
        1130,
        15,
        "900",
        COLORS.navy,
        "center"
    );

    // ---------------------------------------------------------
    // STATUS
    // ---------------------------------------------------------

    drawIconBox(
        ctx,
        848,
        1008,
        "shield"
    );

    drawText(
        ctx,
        "STATUS",
        881,
        1098,
        11,
        "700",
        COLORS.muted,
        "center"
    );

    drawText(
        ctx,
        status.toUpperCase(),
        881,
        1130,
        14,
        "900",
        COLORS.blue,
        "center"
    );

    // ---------------------------------------------------------
    // DOWNLOAD
    // ---------------------------------------------------------

    const link =
        document.createElement("a");

    link.download =
        `mogoma-driver-partner-${referralCode}.png`;

    link.href =
        canvas.toDataURL(
            "image/png",
            1
        );

    link.click();
};